/* eslint react/no-unknown-property: 0 jsx-a11y/no-noninteractive-element-interactions: 0 */

import React from "react";
import cx from "classnames";

const Popover = (props) => {
  const {
    arrowProps,
    baseClassName = "",
    children,
    label,
    placement,
    onClick,
    tooltipProps,
  } = props;
  const placementClass = `${baseClassName}--${placement}`;
  const { style, ...other } = tooltipProps;
  const marginTop = label ? "10px" : 0;

  return (
    <div
      role="tooltip"
      {...other}
      style={{ ...style, marginTop }}
      onClick={onClick}
      placement={placement}
      className={cx(baseClassName, placementClass)}
    >
      <div className={`${baseClassName}__arrow`} {...arrowProps} placement={placement} />
      <div className={`${baseClassName}__content  app-scrollbar`}>{children}</div>
    </div>
  );
};

export default Popover;
